// import $ from "jquery";
// import { useState } from "react";
// import { useSelector } from "react-redux";
// import useApi from "../../../CustomHooks/useApi";
// import useRDService from "../../../CustomHooks/useRDService";
// import DeviceStatus from "./DeviceStatus";
// import AepsForm1 from "./AepsForm1";

// const AepsIntegration1 = () => {

//   const { device, captureFingerprint, loading } =
//     useRDService();

//   const merchantdetails = useSelector(
//     (state) => state.auth?.employeeDetails
//   );

//   const { lat, lng } = useSelector(
//     (state) => state.location
//   );

//   const [processing, setProcessing] = useState(false);

//   const userId = merchantdetails?.username;
 
//   const latitude = lat;
//   const longitude = lng;

//   const {
//     callApi: balanceEnquiryApi
//   } = useApi(
//     "/aeps/fingpay/balance-enquiry",
//     "POST"
//   );

//   const {
//     callApi: cashWithdrawalApi
//   } = useApi(
//     "/aeps/fingpay/cash-withdrawal",
//     "POST"
//   );

//   const {
//     callApi: miniStatementApi
//   } = useApi(
//     "/aeps/fingpay/mini-statement",
//     "POST"
//   );

//   const [popup, setPopup] = useState({
//     show: false,
//     title: "",
//     message: ""
//   });
  

//   const [previousData, setPreviousData] = useState(null);
//   const [clearFormTrigger, setClearFormTrigger] = useState(0);

//   const closePopup = () => {

//     // Clear form on ANY popup OK (success or error)
//     if (
//       popup.show
//     ) {
//       setClearFormTrigger(prev => prev + 1);
//     }

//     setPopup({
//       show: false,
//       title: "",
//       message: ""
//     });
//   };


//   const parsePidXml = (xml) => {

//     const $xml = $(xml);

//     const get = (selector, attr) =>
//       $xml.find(selector).attr(attr) || "0";

//     const infoValue = (name) =>
//       $xml.find(`Info[name='${name}']`).attr("value") ||
//       $xml.find(`Param[name='${name}']`).attr("value") ||
//       "0";

//     return {
//       dc: get("DeviceInfo", "dc"),
//       ci: get("Skey", "ci"),
//       hmac: $xml.find("Hmac").text() || "0",
//       dpId: get("DeviceInfo", "dpId"),
//       mc: get("DeviceInfo", "mc"),
//       pidDataType: get("Data", "type"),
//       sessionKey: $xml.find("Skey").text() || "0",
//       mi: get("DeviceInfo", "mi"),
//       rdsId: get("DeviceInfo", "rdsId"),
//       errCode: get("Resp", "errCode"),
//       errInfo: get("Resp", "errInfo"),
//       fCount: get("Resp", "fCount"),
//       fType: get("Resp", "fType"),
//       iCount: get("Resp", "iCount"), // blank hua toh 0 jayega
//       iType: get("Resp", "iType"),
//       pCount: get("Resp", "pCount"),
//       pType: "0",
//       srno: infoValue("srno"),
//       sysid: infoValue("sysid"),
//       ts: infoValue("ts"),
//       pidData: $xml.find("Data").text() || "0",
//       qScore: get("Resp", "qScore"),
//       nmPoints: get("Resp", "nmPoints"),
//       rdsVer: get("DeviceInfo", "rdsVer"),
//     };
//   };


//   const handleCapture = async (formData) => {

//     try {

//       setProcessing(true);
//       setPreviousData({
//         ...formData
//       });

//       const pidXml = await captureFingerprint("");

//       console.log("Raw PID XML:", pidXml);

//       if (
//         !pidXml ||
//         !pidXml.includes('errCode="0"')
//       ) {
//         setProcessing(false);
//         setPopup({
//           show: true,
//           title: "Failed",
//           message: "Fingerprint Capture Failed"
//         });
//         return;
//       }

//       const pidData = parsePidXml(pidXml);

//       const baseRequest = {
//         bankiin: formData?.bank?.iin,
//         latitude: latitude?.toString(),
//         longitude: longitude?.toString(),
//         biometricData: pidData,
//         aadhaar: formData.aadhaar,
//         mobile: formData.mobile,
//         mid: userId,
//         selectedDevice: device || "MANTRA"
//       };


//       if (formData.txnType === "BE") {

//         const response =
//           await balanceEnquiryApi(baseRequest);

//         console.log(response);

//         if (
//           response?.statuscode === "TXN"
//         ) {

//           setProcessing(false);

//           setPopup({
//             show: true,
//             title: "Balance Enquiry Success",
//             message:
//               `Bank Name : ${response?.data?.bankName}

// Balance : ₹${response?.data?.bankAccountBalance}`
//           });

//         }
//         else {

//           setProcessing(false);

//           setPopup({
//             show: true,
//             title: "Transaction Failed",
//             message:
//               response?.reason ||
//               response?.status ||
//               "Transaction Failed"
//           });

//         }
//       }


//       if (formData.txnType === "CW") {

//         const requestBody = {
//           ...baseRequest,
//           amount: formData.amount
//         };

//         const response = await cashWithdrawalApi(requestBody);

//         console.log(response);

//         if (
//           response?.statuscode === "TXN"
//         ) {

//           setProcessing(false);

//           setPopup({
//             show: true,
//             title: "Cash Withdrawal Success",
//             message: `Bank Name : ${response?.data?.bankName}

// Withdraw Amount : ₹${response?.amount}

// Bank RRN : ${response?.bank_rrn}
// Aadhar No : ${response?.aadhaarNo}`
//           });

//         } else {

//           setProcessing(false);

//           setPopup({
//             show: true,
//             title: "Failed",
//             message:
//               response?.reason ||
//               response?.status ||
//               "Cash Withdrawal Failed"
//           });
//         }
//       }


//       if (formData.txnType === "MS") {

//         const response = await miniStatementApi(baseRequest);

//         console.log(response);

//         if (
//           response?.statuscode === "TXN"
//         ) {

//           const statementText =
//             response?.data?.miniStatement?.length > 0
//               ? response.data.miniStatement
//                 .slice(0, 5)
//                 .map(
//                   item =>
//                     ` ${item.txnType} | ₹${item.amount}`
//                 )
//                 .join("\n")
//               : "No Mini Statement Available";

//           setProcessing(false);

//           setPopup({
//             show: true,
//             title: "Mini Statement Success",
//             message: `

// Available Balance : ₹${response?.data?.bankAccountBalance}

// Recent Transactions:
// ${statementText}`
//           });

//         } else {

//           setProcessing(false);

//           setPopup({
//             show: true,
//             title: "Failed",
//             message:
//               response?.reason ||
//               response?.status ||
//               "Mini Statement Failed"
//           });
//         }
//       }

//     }
//     catch (err) {

//       console.log("AEPS Error", err);

//       setProcessing(false);

//       setPopup({
//         show: true,
//         title: "Error",
//         message:
//           err?.message ||
//           "Transaction Failed"
//       });

//     }
//   };


//   return (
//     <div>

//       <DeviceStatus
//         device={device}
//       />

//       <AepsForm1
//         onSubmit={handleCapture}
//         processing={processing}
//         loading={loading}
//         previousData={previousData}
//         clearFormTrigger={clearFormTrigger}
//       />


//       {popup.show && (
//         <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
//           <div className="bg-white rounded-3xl shadow-2xl p-8 w-[420px] text-center">

//             <h2 className="text-2xl font-semibold">
//               {popup.title}
//             </h2>

//             <p className="mt-5 whitespace-pre-line text-[18px] font-bold text-gray-700 leading-8">
//               {popup.message}
//             </p>

//             <button
//               onClick={closePopup}
//               className="mt-6 bg-blue-600 hover:bg-blue-700 text-white px-10 py-3 rounded-xl"
//             >
//               OK
//             </button>

//           </div>
//         </div>
//       )}

//     </div>
//   );
// };

// export default AepsIntegration1;

import $ from "jquery";
import { useState } from "react";
import { useSelector } from "react-redux";
import useApi from "../../../CustomHooks/useApi";
import useRDService from "../../../CustomHooks/useRDService";
import DeviceStatus from "./DeviceStatus";
import AepsForm1 from "./AepsForm1";

const AepsIntegration1 = () => {
  const { device, captureFingerprint, loading } = useRDService();

  const merchantdetails = useSelector((state) => state.auth?.employeeDetails);
  const { lat, lng } = useSelector((state) => state.location);

  const [processing, setProcessing] = useState(false);

  const userId = merchantdetails?.username;
  const latitude = lat;
  const longitude = lng;

  const { callApi: balanceEnquiryApi } = useApi("/aeps/fingpay/balance-enquiry", "POST");
  const { callApi: cashWithdrawalApi } = useApi("/aeps/fingpay/cash-withdrawal", "POST");
  const { callApi: miniStatementApi } = useApi("/aeps/fingpay/mini-statement", "POST");
  
  // NEW: OTP API Hook
  const { callApi: sendOtpApi } = useApi("/aeps/fingpay/send-otp", "POST");

  const [popup, setPopup] = useState({ show: false, title: "", message: "" });
  
  // NEW: OTP Modal State for CW > 5000
  const [otpModal, setOtpModal] = useState({
    show: false,
    fpTransactionId: "",
    formData: null,
    otpValue: ""
  });

  const [previousData, setPreviousData] = useState(null);
  const [clearFormTrigger, setClearFormTrigger] = useState(0);

  const closePopup = () => {
    if (popup.show) {
      setClearFormTrigger(prev => prev + 1);
    }
    setPopup({ show: false, title: "", message: "" });
  };

  const parsePidXml = (xml) => {
    const $xml = $(xml);

    const get = (selector, attr) => $xml.find(selector).attr(attr) || "0";
    const infoValue = (name) =>
      $xml.find(`Info[name='${name}']`).attr("value") ||
      $xml.find(`Param[name='${name}']`).attr("value") ||
      "0";

    return {
      dc: get("DeviceInfo", "dc"),
      ci: get("Skey", "ci"),
      hmac: $xml.find("Hmac").text() || "0",
      dpId: get("DeviceInfo", "dpId"),
      mc: get("DeviceInfo", "mc"),
      pidDataType: get("Data", "type"),
      sessionKey: $xml.find("Skey").text() || "0",
      mi: get("DeviceInfo", "mi"),
      rdsId: get("DeviceInfo", "rdsId"),
      errCode: get("Resp", "errCode"),
      errInfo: get("Resp", "errInfo"),
      fCount: get("Resp", "fCount"),
      fType: get("Resp", "fType"),
      iCount: get("Resp", "iCount"),
      iType: get("Resp", "iType"),
      pCount: get("Resp", "pCount"),
      pType: "0",
      srno: infoValue("srno"),
      sysid: infoValue("sysid"),
      ts: infoValue("ts"),
      pidData: $xml.find("Data").text() || "0",
      qScore: get("Resp", "qScore"),
      nmPoints: get("Resp", "nmPoints"),
      rdsVer: get("DeviceInfo", "rdsVer"),
    };
  };

  // INTERCEPTOR: Checks if CW > 5000 and requires OTP first
  const handleCapture = async (formData) => {
    if (formData.txnType === "CW" && Number(formData.amount) > 5000) {
      try {
        setProcessing(true);
        const otpPayload = {
          mid: userId,
          bankiin: formData?.bank?.iin,
          latitude: latitude?.toString(),
          longitude: longitude?.toString(),
          mobile: formData.mobile,
          amount: formData.amount,
          aadhaar: formData.aadhaar,
          serviceType: "CW" // Maps to CO internally per your docs
        };

        const otpRes = await sendOtpApi(otpPayload);
        setProcessing(false);

        if (otpRes?.status && otpRes?.data?.fpTransactionId) {
          // Open OTP modal for the customer to provide the 6-digit code
          setOtpModal({
            show: true,
            fpTransactionId: otpRes.data.fpTransactionId,
            formData: formData,
            otpValue: ""
          });
        } else {
          setPopup({
            show: true,
            title: "OTP Initiation Failed",
            message: otpRes?.message || otpRes?.bankResponseMessage || "Could not send Aadhaar OTP."
          });
        }
      } catch (err) {
        setProcessing(false);
        setPopup({
          show: true,
          title: "Error",
          message: err?.message || "Failed to initiate OTP request."
        });
      }
      return; // Stop here and wait for the user to submit the OTP modal
    }

    // Normal flow (BE, MS, or CW <= 5000)
    proceedWithCaptureAndTransaction(formData);
  };

  // ACTUAL TRANSACTION EXECUTION
  const proceedWithCaptureAndTransaction = async (formData, fpTransactionId = null, otp = "") => {
    try {
      setProcessing(true);
      setPreviousData({ ...formData });

      // Pass the OTP to the RD Service hook (wadh is left empty string here)
      const pidXml = await captureFingerprint("", otp);

      console.log("Raw PID XML:", pidXml);

      if (!pidXml || !pidXml.includes('errCode="0"')) {
        setProcessing(false);
        setPopup({ show: true, title: "Failed", message: "Fingerprint Capture Failed" });
        return;
      }

      const pidData = parsePidXml(pidXml);

      // Inject OTP directly into biometricData if provided
      if (otp) {
        pidData.otp = otp;
      }

      const baseRequest = {
        bankiin: formData?.bank?.iin,
        latitude: latitude?.toString(),
        longitude: longitude?.toString(),
        biometricData: pidData,
        aadhaar: formData.aadhaar,
        mobile: formData.mobile,
        mid: userId,
        selectedDevice: device || "MANTRA"
      };

      // Attach txnOtpRequestId for high-value transactions
      if (fpTransactionId) {
        baseRequest.txnOtpRequestId = fpTransactionId;
      }

      if (formData.txnType === "BE") {
        const response = await balanceEnquiryApi(baseRequest);
        if (response?.statuscode === "TXN") {
          setPopup({
            show: true,
            title: "Balance Enquiry Success",
            message: `Bank Name : ${response?.data?.bankName}\n\nBalance : ₹${response?.data?.bankAccountBalance}`
          });
        } else {
          setPopup({
            show: true,
            title: "Transaction Failed",
            message: response?.reason || response?.status || "Transaction Failed"
          });
        }
      }

      if (formData.txnType === "CW") {
        const requestBody = { ...baseRequest, amount: formData.amount };
        const response = await cashWithdrawalApi(requestBody);
        
        if (response?.statuscode === "TXN") {
          setPopup({
            show: true,
            title: "Cash Withdrawal Success",
            message: `Bank Name : ${response?.data?.bankName}\n\nWithdraw Amount : ₹${response?.amount}\n\nBank RRN : ${response?.bank_rrn}\nAadhar No : ${response?.aadhaarNo}`
          });
        } else {
          setPopup({
            show: true,
            title: "Failed",
            message: response?.reason || response?.status || "Cash Withdrawal Failed"
          });
        }
      }

      if (formData.txnType === "MS") {
        const response = await miniStatementApi(baseRequest);
        if (response?.statuscode === "TXN") {
          const statementText = response?.data?.miniStatement?.length > 0
            ? response.data.miniStatement.slice(0, 5).map(item => ` ${item.txnType} | ₹${item.amount}`).join("\n")
            : "No Mini Statement Available";

          setPopup({
            show: true,
            title: "Mini Statement Success",
            message: `Available Balance : ₹${response?.data?.bankAccountBalance}\n\nRecent Transactions:\n${statementText}`
          });
        } else {
          setPopup({
            show: true,
            title: "Failed",
            message: response?.reason || response?.status || "Mini Statement Failed"
          });
        }
      }

    } catch (err) {
      console.log("AEPS Error", err);
      setPopup({ show: true, title: "Error", message: err?.message || "Transaction Failed" });
    } finally {
      setProcessing(false);
    }
  };

  // Handle OTP submission from the modal
  const handleOtpSubmit = () => {
    const { formData, fpTransactionId, otpValue } = otpModal;
    if (otpValue.length !== 6) {
      alert("Please enter a valid 6-digit OTP");
      return;
    }
    // Close modal and proceed to capture
    setOtpModal({ show: false, fpTransactionId: "", formData: null, otpValue: "" });
    proceedWithCaptureAndTransaction(formData, fpTransactionId, otpValue);
  };


  return (
    <div>
      <DeviceStatus device={device} />

      <AepsForm1
        onSubmit={handleCapture}
        processing={processing}
        loading={loading}
        previousData={previousData}
        clearFormTrigger={clearFormTrigger}
      />

      {/* NEW: OTP Modal */}
      {otpModal.show && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-[60]">
          <div className="bg-white rounded-3xl shadow-2xl p-8 w-[420px] text-center">
            <h2 className="text-2xl font-semibold mb-2">Enter OTP</h2>
            <p className="text-gray-600 mb-6 text-sm">
              An OTP has been sent to the customer's linked mobile number for this high-value transaction.
            </p>
            
            <input
              type="text"
              maxLength="6"
              placeholder="••••••"
              value={otpModal.otpValue}
              onChange={(e) => setOtpModal({ ...otpModal, otpValue: e.target.value.replace(/\D/g, '') })}
              className="w-full border-2 border-gray-300 rounded-xl p-3 text-center text-2xl tracking-[0.5em] font-bold focus:border-blue-500 focus:outline-none mb-6"
            />

            <div className="flex gap-4">
              <button
                onClick={() => setOtpModal({ show: false, fpTransactionId: "", formData: null, otpValue: "" })}
                className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-3 rounded-xl font-semibold transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleOtpSubmit}
                disabled={otpModal.otpValue.length < 6}
                className="flex-1 bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 text-white px-4 py-3 rounded-xl font-semibold transition-colors"
              >
                Verify & Capture
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Existing Alert Popup */}
      {popup.show && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-3xl shadow-2xl p-8 w-[420px] text-center">
            <h2 className="text-2xl font-semibold">{popup.title}</h2>
            <p className="mt-5 whitespace-pre-line text-[18px] font-bold text-gray-700 leading-8">
              {popup.message}
            </p>
            <button
              onClick={closePopup}
              className="mt-6 bg-blue-600 hover:bg-blue-700 text-white px-10 py-3 rounded-xl"
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AepsIntegration1;